import {connect} from 'react-redux';
import {favoriteLocation, selectLocation} from '../../../addressbook/locations';
import {FormattedMessage} from 'react-intl';
import Address from '../../../../frontend/addressbook/components/Address';
import Alert from '../../../../ui/Alert';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Positions from './position/Positions';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import LabelDownload from '../../components/LabelDownload';
import {resetOrder} from '../../order';
import styles from './css/Confirmation.scss';
import {withRouter} from "react-router-dom";
import Button from "../../../../ui/Button";

export class ConfirmationStep extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        location: ImmutablePropTypes.map.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        orders: ImmutablePropTypes.map.isRequired,
        products: ImmutablePropTypes.map.isRequired,
        services: ImmutablePropTypes.map.isRequired,
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const {order} = this.props;
        this.props.dispatch(favoriteLocation(order.get('location')));
    }

    componentWillUnmount() {
        this.props.dispatch(resetOrder());
    }

    render() {
        const {products, services, order: currentOrder, orders, location} = this.props;

        const order = orders.get(currentOrder.get('id'));
        if (!order) {
            if (currentOrder.get('state') === 'dispatched_failure') {
                return (
                    <div className={styles.container}>
                        <div>
                            <h1>
                                <FormattedMessage id={'common.helper.validation.there_were_errors'}/>
                            </h1>
                        </div>
                        <Alert key='danger' type='danger'>
                            <FormattedMessage id={'frontend.form_confirmation.text.order_failed'}/>
                        </Alert>
                        <br/>
                        <Button link to='/' emphasis='primary'>
                            <FormattedMessage id='frontend.orders.dashboard.new_order' />
                        </Button>
                    </div>);
            }
            return null;
        }

        const service = order.get('service');
        let serviceType = service.get('alias').split('.')[1];

        // TODO: This can/should be extracted into a selector
        const orderedPositions = currentOrder.get('positions').reduce((result, positions) => {
            return result.concat(positions.keySeq().toList());
        }, Immutable.List());

        // TODO: We reduce the positions to only the selected positions since
        // the <Position> component renders all available positions. Check with
        // Julien if this is the way to go.
        const positions = products.filter(pos => {
            return orderedPositions.includes(pos.get('id'));
        });

        console.log(positions);

        if (
            serviceType === "pickup"
            && positions.count() === 1
            && positions.get(1)
            && positions.get(1).get('alias') === "product.single_unit"
        ) {
            serviceType = 'singleunit';
        }

        const requiresLabel = !!order.getIn(['labelStatus', 'required'], false);

        return (
            <div className={styles.container}>
                <h1>
                    <FormattedMessage id={'frontend.form_confirmation.headline.heading'}/>
                    {' - '}
                    {order.get('code')}
                </h1>


                {requiresLabel && <LabelDownload order={order}/>}

                {/* Address */}
                <h4>
                    <FormattedMessage id={(serviceType
                        ? `frontend.form_confirmation.headline.selected_address_${serviceType}`
                        : 'frontend.form_confirmation.headline.selected_address'
                    )}/>
                </h4>
                <Address location={location}/>

                {/* Products */}
                <div className={styles.block}>
                    <h4>
                        <FormattedMessage id={'frontend.form_confirmation.headline.selected_products'}/>
                    </h4>
                    <Positions
                        positions={positions}
                        services={services}
                        order={currentOrder}
                        isEditable={false}
                    />
                </div>

                <Alert>
                    <p>
                        <FormattedMessage id={'frontend.form_confirmation.label.contact'}/>
                        {' '}
                        <a href={`mailto:info@takeback.eu?subject=Takeback ${order.get('code')}`}>
                            info@takeback.eu
                        </a>
                    </p>
                </Alert>
            </div>
        );
    }
}

export default withRouter(connect(state => ({
    location: selectLocation(state, state.order.get('location')),
    order: state.order,
    orders: state.orders,
    products: state.products,
    services: state.services,
}))(ConfirmationStep));
